module.exports = "/images/backgroundMobileWithOutMoped.svg";